/**
 * Basket UI Controller
 *
 * TODO Remove this by using a framework like React and don't bother with DOM
 *
 * @author Emre Piskin <emre.piskin@takeaway.com>
 */

import DOM from '../lib/dom'
import ENUM from '../lib/enums'

const $ = (selector, container = document) => container.querySelector(selector)
// const $$ = (selector, container = document) => container.querySelectorAll(selector)

/**
 * UI selectors
 * @type {{$input: string, $$links: string, $linksContainer: string}}
 * @private
 */
let _SELECTORS = {
  $container: '#js-basket-container',
  $toast: '#tooltip'
}

/**
 * UI elements
 * @type {{$input: function(): (Node), $$links: function(): (NodeList), $linksContainer: function(): (Node)}}
 * @private
 */
const _ELEMENTS = {
  $container: () => $(_SELECTORS.$container),
  $toast: () => $(_SELECTORS.$toast)
}

export default class UI {
  /**
   * Render methods
   */

  static renderContainer ({ i18n, deliveryType } = {}) {
    const templateContainer = `
      <div class="menu-cart-fixed">

        <div class="basket-notification" ${deliveryType === ENUM.DeliveryMethod.Type.Pickup ? `` : `style="display: none"`}>
          ${i18n.PICKUP_NOTIFICATION}
        </div>

        <div class="missing" style="display: none">
          <h3 class="cart-meal-error">{{The following products are not available and removed from your basket.}}</h3>
          <div class="missing_products"></div>
        </div>

        <div class="mismatch" style="display: none">
          <h3 class="cart-meal-error">{{Some products have been changed. We've updated them for you.}}</h3>
        </div>

        <div id="products"></div>
        <div id="discounts"></div>
        <div id="autoaddproducts"></div>
        <div id="sum" class="cart-sum"></div>

        <div id="empty" class="jig-cart-empty-state visible">
          <div class="jig-cart-empty-state-icon"></div>
          <h3>${i18n.BASKET_IS_EMPTY}</h3>
        </div>
      
        <div class="cart-row" id="cart-exclusive" style="display: none">
          <span class="cart-sum-name cart-meal-exclude">${i18n.minimumExclusionProducts}</span>
        </div>

        <section class="cartbutton">
          <a class="cartbutton-button"
             onclick="basket.proceedCheckout()">
            ${i18n.ORDER}
          </a>
          <div class="minimumorderamount-reached"></div>
        </section>

        <div class="cart-row" id="cart-exclusive-only" style="display: block">
          <span class="cart-sum-name cart-meal-exclude-only">${i18n.ONLY_EXCLUDED_PRODUCTS_WARNING}</span>
        </div>
      </div>`

    DOM.html(_ELEMENTS.$container(), templateContainer)
  }
}
